import { Routes } from '@angular/router';
import { HomeDevComponent } from './home-dev/home-dev.component';
import { InvalidezHomeComponent } from './tramite-pension-invalidez/pages/invalidez-home/invalidez-home.component';

export const APP_ROUTES: Routes = [
  {
    path: '', component: HomeDevComponent, pathMatch: 'full'
  },
  {
    path: 'tramite-pensiones-invalidez',
    component: InvalidezHomeComponent,
  },
];
